<template>
  <div class="table-responsive">
    <table id="oTable" class="table table-bordered ext-table" style="margin-bottom: 2px;" >
      <thead>
      <tr>
        <th class="key-tr-width">{{keyTitle}}</th>
        <th class="value-tr-width">{{textTitle}}</th>
        <th class="action-tr-width">{{actionTitle}}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(jsonItem,index) in jsonData" :key="index">
        <td><input contenteditable="true" class="tr-input" @input="change" v-model="jsonData[index].key" /></td>
        <td><input contenteditable="true" class="tr-input" @input="change" v-model="jsonData[index].text" /></td>
        <td><label @click="deleteRow(index)" class="tr-input" style=":">
          <span><Icon type="ios-close"  size="30"></Icon></span></label></td>
      </tr>
      </tbody>
    </table>
    <div style="text-align:center;">
      <label class="btn btn-info" @click="addRow">
        <span><Icon type="ios-add"></Icon></span>添加
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'edit-json-table',
  props: {
    keyTitle: {
      default: '填写Key'
    },
    textTitle: {
      default: '填写Value'
    },
    actionTitle: {
      default: '移除'
    },
    value: {
      default: ''
    }
  },
  data () {
    return {
      jsonString: '',
      jsonData: [{ key: '', text: '' }]
    }
  },
  methods: {
    addRow: function () {
      this.jsonData.push({ key: '', text: '' })
      this.transferTableToJson()
    },
    deleteRow: function (index) {
      if (this.jsonData.length === 1) {
        this.jsonData[0].key = ''
        this.jsonData[0].text = ''
      } else {
        this.jsonData.splice(index, 1)
      }
      this.transferTableToJson()
    },
    change: function () {
      this.transferTableToJson()
    },
    transferTableToJson: function () {
      this.jsonString = JSON.stringify(this.jsonData)
    }
  },
  watch: {
    jsonString: function () {
      let tempData = ''
      let temString = this.jsonString
      try {
        tempData = JSON.parse(this.jsonString)
      } catch (e) {
        tempData = ''
      }
      if (tempData && (tempData instanceof Array) && tempData.length === 1) {
        if (tempData[0].key === '' && tempData[0].text === '') {
          temString = ''
        }
      }
      this.$emit('input', temString)
    },
    value: function (val) {
      this.jsonString = ''
      this.jsonData = [{ key: '', text: '' }]
      if (val !== '') {
        try {
          let extJson = JSON.parse(val)
          if (Array.isArray(extJson)) {
            if (extJson[0].hasOwnProperty('key') && extJson[0].hasOwnProperty('text')) {
              this.jsonString = val
              this.jsonData = JSON.parse(this.jsonString)
            }
          } else {
            let transformData = []
            for (let p in extJson) {
              transformData.push({ key: p, text: extJson[p] })
            }
            this.jsonString = JSON.stringify(transformData)
            this.jsonData = [].concat(transformData)
          }
        } catch (e) {
          console.error('edit json table get error format data')
        }
      }
    }
  },
  mounted () {
    if (this.value !== '') {
      this.jsonString = this.value
      this.jsonData = JSON.parse(this.jsonString)
    }
  }
}
</script>

<style scoped>
  .ext-table {
    table-layout: fixed;
  }
  .action-tr {
    width: 100%;
    height: 100%;
    padding: 0 5px;
    text-align: center;
  }
  .tr-input {
    border: none !important;
    outline:none;
    width: 100%;
    padding: 0 5px;
    text-align: center;
  }
  .tr-input span {
    color: red;
  }
  .key-tr-width {
    width: 30%;
  }
  .value-tr-width {
    width: 60%;
  }
  .action-tr-width {
    width: 10%;
  }

  .ext-table {
    table-layout: fixed;
  }
  .table {
    width: 100%;
    margin-bottom: 20px;
    background-color: transparent;
    border-spacing: 0;
    border-collapse: collapse;
    display: table;
  }

  table
  {
    border-collapse:collapse;
  }
  table, td, th
  {
    border:1px solid rgb(221,222,225);
  }
</style>
